import { render } from "./DefaultPropertyGenerator.vue?vue&type=template&id=6d772534"
import script from "./DefaultPropertyGenerator.vue?vue&type=script&lang=js"
export * from "./DefaultPropertyGenerator.vue?vue&type=script&lang=js"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QBtn});
